export default __webpack_public_path__ + "static/solution-banner-2a5cd1ec2c04cf1ef6d83f0c93012e51.png";